import StudioPlanToDisplay from '../entities/entitiesToDisplay/pricingPlans/StudioPlanToDisplay';
import ProPlanToDisplay from '../entities/entitiesToDisplay/pricingPlans/ProPlanToDisplay';

export const PRO_PLAN = 'Pro Plan';
export const STUDIO_PLAN = 'Studio Plan';

export default class PricingPlanToDisplayFactory {
	static buildersByName = {
		[ STUDIO_PLAN ]: ( pricingPlan, isMonthly ) => new StudioPlanToDisplay( { pricingPlan, isMonthly } ),
		[ PRO_PLAN ]: ( pricingPlan, isMonthly ) => new ProPlanToDisplay( { pricingPlan, isMonthly } )
	};

	static forPricingPlan( pricingPlan, isMonthly ) {
		return PricingPlanToDisplayFactory.fromPlan( pricingPlan, isMonthly );
	}

	static fromPlan( pricingPlan, isMonthly ) {
		if ( pricingPlan.name in this.buildersByName ) {
			return this.buildersByName[ pricingPlan.name ]( pricingPlan, isMonthly );
		}

		return undefined;
	}
}
